import { render, staticRenderFns } from "./H5Orders.vue?vue&type=template&id=550a1672&scoped=true"
import script from "./H5Orders.vue?vue&type=script&lang=js"
export * from "./H5Orders.vue?vue&type=script&lang=js"
import style0 from "./H5Orders.vue?vue&type=style&index=0&id=550a1672&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550a1672",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('550a1672')) {
      api.createRecord('550a1672', component.options)
    } else {
      api.reload('550a1672', component.options)
    }
    module.hot.accept("./H5Orders.vue?vue&type=template&id=550a1672&scoped=true", function () {
      api.rerender('550a1672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/order-receive/h5/H5Orders.vue"
export default component.exports